export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-12">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-accent-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">投稿合作</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            欢迎动漫创作者、字幕组、同人画师联系我们。樱花动漫网期待与更多动漫爱好者一起，
            为观众带来更丰富的动漫内容和更好的在线观看体验。合作投稿请发送邮件至下方地址。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line text-lg"></i>
              contact@sakura-anime.com
            </a>
            <a
              href="#contact"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:border-accent-400 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-3-line text-lg"></i>
              在线咨询
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}